import { render, staticRenderFns } from "./ElectricItem.vue?vue&type=template&id=233be204&lang=pug&"
import script from "./ElectricItem.vue?vue&type=script&lang=js&"
export * from "./ElectricItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports